import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    spotDatas: null,
    selectedSpotData: null,
    selectedSpotId: null
  },
  mutations: {
    setSpotDatas (state, spots) {
      state.spotDatas = spots
    },
    selectSpotData (state, id) {
      state.selectedSpotId = id
    }
  },
  getters: {
    getSelectedSpotData (state) {
      if (state.selectedSpotId === null ||
          state.spotDatas === null) {
        return null
      }
      if (state.selectedSpotData != null &&
          state.selectedSpotData['id'] === state.selectedSpotId) {
        return state.selectedSpotData
      } else {
        state.selectedSpotData = state.spotDatas.find(
          spot => spot['id'] === state.selectedSpotId
        )
        return state.selectedSpotData
      }
    }
  }
})

export default store
